import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, Input, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { debounce } from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import SaveReportForm from 'pages/Components/reportForm';
import { SearchModel } from 'pages/model';
import { useTranslation } from 'react-i18next';
import { CommonModel } from 'services/Main/common_services';
import { CTCDEventReportModel } from 'services/Main/eventCampaign_services';
import { commonPresenter, commonStore, eventCampaignPresenter, eventCampaignStore, uiStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { useResizableColumns } from 'utils/reportHelper';
import { AiOutlineDownload } from 'react-icons/ai';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';

const { RangePicker } = DatePicker;

const createEventReport = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.bc-ctcdev') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    const [listStatus, setListStatus] = useState<CommonModel[]>([]);
    const [listContentType, setListContentType] = useState<CommonModel[]>([]);

    const defaultColumn: ProColumns<CTCDEventReportModel>[] = [
      // stt
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 60,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Mã chiến dịch
      {
        title: t('event.campaign-code'),
        dataIndex: 'campaignCode',
        key: 'campaignCode',
        width: 120,
        fixed: 'left',
      },
      // Tên chiến dịch
      {
        title: t('event.campaign-name'),
        dataIndex: 'campaignName',
        key: 'campaignName',
        width: 200,
        fixed: 'left',
      },
      // Tên nội dung
      {
        title: t('event.content-name'),
        dataIndex: 'contentName',
        key: 'contentName',
        width: 200,
      },
      // Tên nhóm
      {
        title: t('event.group-name'),
        dataIndex: 'targetGroupName',
        key: 'targetGroupName',
        width: 150,
      },
      // Trạng thái
      {
        title: t('event.status'),
        dataIndex: 'status',
        key: 'status',
        width: 100,
      },
      // Lịch gửi
      {
        title: t('event.sent-date'),
        dataIndex: 'lichGui',
        key: 'lichGui',
        width: 150,
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Người tạo
      {
        title: t('event.create-by'),
        dataIndex: 'createBy',
        key: 'createBy',
        width: 150,
      },
      // Ngày tạo
      {
        title: t('event.create-date'),
        dataIndex: 'createTime',
        key: 'createTime',
        width: 150,
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      //Loại nội dung (Email/SMS)
      {
        title: t('event.content-type'),
        dataIndex: 'typeContent',
        key: 'typeContent',
        width: 120,
      },
      // Tổng số người gửi
      {
        title: t('event.senders'),
        dataIndex: 'totalSend',
        key: 'totalSend',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Số lượng đã gửi
      {
        title: t('event.sent'),
        dataIndex: 'alreadySend',
        key: 'alreadySend',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Số lượng chưa gửi
      {
        title: t('event.unsent'),
        dataIndex: 'notSend',
        key: 'notSend',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Số lượng mở mail
      {
        title: t('event.mail-open'),
        dataIndex: 'alreadyOpenMail',
        key: 'alreadyOpenMail',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Số lượng unfollow
      {
        title: t('event.unfollow'),
        dataIndex: 'unfollow',
        key: 'unfollow',

        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // // Số người click thành phần mail
      // {
      //   title: t('event.click-mail'),
      //   dataIndex: 'BHdenNgay',
      //   key: 'BHdenNgay',
      //   width: 100,
      // },
    ];
    //--- DATA TABLE ------------------------------------------------------------
    const [dataTable, setDataTable] = useState<CTCDEventReportModel[]>([]);

    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      fromTime: undefined,
      toTime: undefined,
    });

    // Loading
    const [exportLoading, setExportLoading] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const [disabledSendDay, setDisabledSendDay] = useState(false);
    const [disabledCreateDate, setDisabledCreateDate] = useState(false);

    const [columns, setColumns] = useState<ProColumns<CTCDEventReportModel>[]>(defaultColumn);

    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------
    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string, type: 'lich' | 'ngaytao') => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        switch (type) {
          case 'lich':
            form.setFieldValue('sentDate', [
              dayjs(commonStore.commonDate.fromDate),
              dayjs(commonStore.commonDate.toDate),
            ]);
            break;
          case 'ngaytao':
            form.setFieldValue('createDate', [
              dayjs(commonStore.commonDate.fromDate),
              dayjs(commonStore.commonDate.toDate),
            ]);
            break;
        }
      } else {
        switch (type) {
          case 'lich':
            form.setFieldValue('sentDate', undefined);
            break;
          case 'ngaytao':
            form.setFieldValue('createDate', undefined);
            break;
        }
      }
    };

    // Lấy  danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListCreateBy(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = debounce(getListCreateBy, 500);

    // Lấy danh sách Trạng thái
    const getListStatus = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'CampaignStatus');
      if (commonStore.commonRespone.isSuccess) {
        setListStatus(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách Loại nội dụng
    const getListContentType = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'CampaignContentType');
      if (commonStore.commonRespone.isSuccess) {
        setListContentType(commonStore.commonRespone.data);
      }
    };

    const getDataTable = async (data: SearchModel) => {
      await eventCampaignPresenter.getDataReportCTCDEvent(eventCampaignStore, { ...data, lang: uiStore.language });
      if (eventCampaignStore.ctEventReport.isSuccess) {
        const data = eventCampaignStore.ctEventReport.data;
        setDataTable(data);
        return data;
      } else {
        message.error(eventCampaignStore.ctEventReport.message);
        return [];
      }
    };

    useEffect(() => {
      (async () => {
        getListCommonDate();
        getListContentType();
        getListCreateBy();
        getListStatus();
      })();
    }, []);

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // hidden modal (Add)

    // ============================================LƯU MẪU BÁO CÁO =========================================

    const tableRef = useRef<ActionType>();
    const constDataName = 'BCCTChienDichEvent';
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns<CTCDEventReportModel>(columns, setColumns, constDataName);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.bc-ctcdev'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<CTCDEventReportModel>
            className="[&_.ant-table-thead_th]:!text-center"
            bordered
            columns={columns}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            dataSource={dataTable}
            actionRef={tableRef}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: eventCampaignStore.ctEventReport.paging?.totalCount,
            }}
            request={async (params = {}, sort, filter) => {
              if (isSearch) {
                const data = await getDataTable({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
                console.log(data);

                if (Object.values(sort).length) {
                  setDataPaging({
                    ...dataPaging,
                    paging: {
                      ...dataPaging.paging,
                      orderBy:
                        Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      orderByDesc:
                        Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    },
                  });
                }
                return {
                  data: data,
                  success: eventCampaignStore.ctEventReport.isSuccess,
                };
              }
              return [];
            }}
            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            toolBarRender={() => [
              <>
                {checkPermission('EXPORT') ? (
                  <CustomButton
                    size="middle"
                    loading={exportLoading}
                    className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                    type="primary"
                    onClick={async () => {
                      setExportLoading(true);
                      await eventCampaignPresenter.exportReport({ ...dataPaging, lang: uiStore.language });
                      setExportLoading(false);
                    }}
                  >
                    <AiOutlineDownload className="block text-base" />
                    <span className="block">{t('btn.export')}</span>
                  </CustomButton>
                ) : (
                  ''
                )}
              </>,
              // nút lưu mẫu bc
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          className="lg:!w-[50%]"
          onClose={onClose}
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              onClick={() => {
                form.submit();
              }}
              className="my-auto ml-auto"
              type="primary"
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm form={form} onFinish={(values) => {
            setIsSearch(true);
            const lichGui = values['sentDate'];
            const ngayTao = values['createDate'];

            let calenFrom = undefined;
            let calenTo = undefined;
            let fromTime = undefined;
            let toTime = undefined;

            if (lichGui) {
              calenFrom = lichGui[0].format('YYYY-MM-DD') || undefined;
              calenTo = lichGui[1].format('YYYY-MM-DD') || undefined;
            }
            if (ngayTao) {
              fromTime = ngayTao[0].format('YYYY-MM-DD') || undefined;
              toTime = ngayTao[1].format('YYYY-MM-DD') || undefined;
            }

            setDataPaging({
              ...values,
              calenFrom: calenFrom,
              calenTo: calenTo,
              fromTime: fromTime,
              toTime: toTime,
              paging: { ...dataPaging.paging, pageIndex: 1 },
            });

            tableRef.current?.reload();
          }}>
            {/* Mã chiến dịch */}
            <SearchItem name={'campaignCode'} label={t('event.campaign-code')}>
              <Input />
            </SearchItem>
            {/* Tên chiến dịch */}
            <SearchItem name={'campaignName'} label={t('event.campaign-name')}>
              <Input />
            </SearchItem>
            {/* Trạng Thái */}
            <SearchItem name={'status'} label={t('event.status')}>
              <CustomSelect
                options={listStatus}
                filterOption={false}
                fieldNames={{ label: 'value', value: 'key' }}
                allowClear
              />
            </SearchItem>
            {/* Ngày tạo (common)*/}
            <SearchItem name={'commonCreateDate'} label={t('event.create-date')} start>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledCreateDate(option.key === 'Custom' ? false : true);
                    await getDateByKey(option.key, 'ngaytao');
                  } else {
                    setDisabledCreateDate(false);
                    form.setFieldValue('createDate', undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* Ngày tạo (từ ngày -> đến ngày) */}
            <SearchItem name={'createDate'} col2>
              <RangePicker disabled={disabledCreateDate} format="DD/MM/YYYY" className="w-full" />
            </SearchItem>
            {/* Lịch gửi (common)*/}
            <SearchItem name={'commonSentDate'} label={t('event.sent-date')}>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledSendDay(option.key === 'Custom' ? false : true);
                    await getDateByKey(option.key, 'lich');
                  } else {
                    setDisabledSendDay(false);
                    form.setFieldValue('sentDate', undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/*  Lịch gửi (từ ngày -> đến ngày) */}
            <SearchItem name={'sentDate'} col2>
              <RangePicker disabled={disabledSendDay} format="DD/MM/YYYY" className="w-full" />
            </SearchItem>

            {/* Nội dung */}
            <SearchItem name={'typeContent'} label={t('event.loai-nd')}>
              <CustomSelect
                options={listContentType}
                filterOption={false}
                fieldNames={{ label: 'value', value: 'key' }}
                allowClear
              />
            </SearchItem>
            {/* Người tạo */}
            <SearchItem name={'createBy'} label={t('event.create-by')}>
              <CustomSelect
                options={listCreateBy}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createEventReport;
